import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../app/stores/store';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import _ from 'lodash';

function OrderTable() {
  const { activityStore, dashboardStore } = useStore();
  const { viewTemplateOrderDetails } = activityStore;
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    activityStore.viewTemplatePageNumber = 1;
    if (id) {
      activityStore.viewTemplateSearch(id, '', 1, 5);
    }
    // eslint-disable-next-line
  }, [id]);

  const paginateFunction = (e: number) => {
    //search filter params (search some)
    //1) Pagination + Search
    activityStore.viewTemplatePageNumber = e;
    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      activityStore.viewTemplateSearch(
        id || '',
        JSON.stringify(dashboardStore.dashboard.searchfilterparams),
        e,
        5,
      );
    }
    //pagination + Sort -> OrderData(Ascending or Descending) Order Name (Title or langugage or year)
    else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      let params = {
        ItemId: id || '',
        SortValue: dashboardStore.dashboard.orderName || '',
        SortBy: dashboardStore.dashboard.orderData || '',
        PageNumber: e,
        PageSize: 5,
      };
      activityStore.viewTemplateSort(params);
    }
    //only Pagination without Search or Sort
    else {
      activityStore.viewTemplateSearch(id || '', '', e, 5);
    }
    //Setting the pagenumber to dashboardStore so we can have track of page even after rerender
    // dashboardStore.setCRTablePageNumFunc(e);
    //Setting the page number in state
  };

  // const removeCol = "isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost";
  // const viewTemplate: any = JSON.parse(JSON.stringify(viewTemplateOrderDetails));
  // viewTemplate.map((i: any) => removeCol.split(",").map((j) => delete i[j]));

  return (
    <Segment clearing responsive={true}>
      <Header
        icon="list"
        size="huge"
        dividing
        as="h1"
        content="View Workflow"
        sub
        color="grey"
      />
      {activityStore.isViewTemplateLoading ? (
        <LoadingComponent />
      ) : (
        <DynamicTableComponent
          data={viewTemplateOrderDetails}
          name={'viewTemplateTable'}
          actiontype={''}
          pageFunc={paginateFunction}
          pageNumData={activityStore.viewTemplatePageNumber}
          searchFuncData={() => {}}
        />
      )}
    </Segment>
  );
}

export default observer(OrderTable);
